export default {
  App: "/",
  Home: "/home",

  SignIn: "/sign-in",

  Users: "/users",
  UsersCreate: "/users/create",
  UsersDetail: "/user/detail",

  GroupEmployee: "/group-employee",
  GroupEmployeeCreate: "/group-employee/create",
  GroupEmployeeDetail: "/group-employee/detail",

  Employees: "/employees",
  EmployeesCreate: "/employees/create",
  EmployeesDetail: "/employees/detail",

  Roles: "/roles",
  RolesCreate: "/roles/create",
  RoleDetail: "/roles/detail",

  UserGroups: "/user-groups",
  UserGroupsCreate: "/user-groups/create",
  UserGroupsDetail: "/user-groups/detail",

  Departments: "/departments",
  DepartmentsCreate: "/departments/create",
  DepartmentsDetail: "/departments/detail",

  Branches: "/branches",
  BranchesCreate: "/branches/create",
  BranchesDetail: "/branches/detail",

  Titles: "/titles",
  TitlesCreate: "/titles/create",
  TitlesDetail: "/titles/detail",

  Permissions: "/permissions",
  OrganizationalChart: "/organization-chart",

  Applications: "/applications",
  ApplicationDetail: "/applications/detail",
  ApplicationCreate: "/applications/create",

  Features: "/features",
  FeatureDetail: "/features/detail",
  FeatureCreate: "/features/create",

  Tenants: "/tenants",
  TenantDetail: "/tenants/detail",
  TenantCreate: "/tenants/create",

  Organizations: "/organizations",
  OrganizationDetail: "/organizations/detail",
  OrganizationCreate: "/organizations/create",

  Partners: "/partners",
  PartnersDetail: "/partners/detail",
  PartnersCreate: "/partners/create",

  Authentication: {
    SignIn: "/authentication/sign-in",
  },

  WorkLevels: "/workLevels",
  WorkLevelDetail: "/workLevels/detail",
  WorkLevelCreate: "/workLevels/create",

  ContractTypes: "/contractTypes",
  ContractTypeDetail: "/contractTypes/detail",
  ContractTypeCreate: "/contractTypes/create",
} as const;
